import React from "react";
import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "What types of cleaning services does Tidy Clean Up provide?",
    a: "Tidy Clean Up provides professional cleaning services for commercial, aviation, industrial, and specialty spaces. Our team handles office cleaning, aircraft cleaning, hangar cleaning, warehouse cleaning, facility cleaning, event clean-up, and customized cleaning plans for businesses of all sizes.",
  },
  {
    q: "Do you provide commercial cleaning services near Southern Pines, NC?",
    a: "Yes. Tidy Clean Up provides commercial cleaning services in Southern Pines, Moore County, and surrounding areas throughout the Carolinas. We support businesses with recurring cleaning, deep cleaning, office maintenance, and specialty cleaning services.",
  },
  {
    q: "Do you clean private jets and aircraft?",
    a: "Yes. Tidy Clean Up offers aviation cleaning services for private aircraft, commercial aircraft, and hangar facilities. Services may include cabin cleaning, interior detailing, surface care, and keeping aviation spaces clean and ready for passengers and crews.",
  },
  {
    q: "What is included in office cleaning services?",
    a: "Our office cleaning services can include workstation and common area cleaning, restroom cleaning and sanitation, trash removal, dusting and surface cleaning, floor care, breakroom cleaning, and customized daily, weekly, or monthly cleaning schedules.",
    list: [
      "Workstation and common area cleaning",
      "Restroom cleaning and sanitation",
      "Trash removal",
      "Dusting and surface cleaning",
      "Floor care",
      "Breakroom cleaning",
      "Customized daily, weekly, or monthly cleaning schedules",
    ],
  },
  {
    q: "Do you offer industrial cleaning?",
    a: "Yes. Tidy Clean Up provides industrial cleaning for warehouses, production spaces, shops, and facilities. Our team helps maintain cleaner, safer work environments with reliable facility cleaning solutions.",
  },
  {
    q: "Do you provide one-time cleaning or only recurring services?",
    a: "We offer both. Tidy Clean Up can help with one-time deep cleans, event clean-up, move-in/move-out cleaning, seasonal cleaning projects, and ongoing commercial cleaning contracts.",
  },
  {
    q: "Do you bring your own cleaning supplies and equipment?",
    a: "Yes. Our team arrives prepared with professional cleaning supplies and equipment needed for your facility. We can also discuss specific products or cleaning requirements based on your space.",
  },
  {
    q: "Can you clean after events?",
    a: "Yes. Tidy Clean Up provides event cleaning before, during, and after events. We help with venue reset, trash removal, restroom cleaning, surface cleaning, and preparing the space for the next guest.",
  },
  {
    q: "How much does commercial cleaning cost?",
    a: "Commercial cleaning pricing depends on the size of the space, cleaning frequency, type of facility, and specific services needed. Tidy Clean Up provides custom quotes based on your property and cleaning goals.",
  },
  {
    q: "Why choose Tidy Clean Up?",
    a: "Tidy Clean Up combines professional standards with personal service. Instead of managing multiple cleaning vendors, we provide one trusted partner for offices, aircraft, industrial spaces, events, and specialty cleaning needs. One partner. Every facility. Always spotless.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-32">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <HelpCircle className="w-5 h-5 text-[#e8a428]" strokeWidth={1.8} />
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428]">
              Frequently Asked Questions
            </span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-4">
            Answers, before you even ask.
          </h2>
          <p className="text-[16px] text-[#143527]/75 max-w-2xl mx-auto">
            Everything our clients ask before partnering with Tidy Clean Up &mdash; covering aviation,
            commercial, industrial and event facility services across the Carolinas.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="bg-[#f4ebde] rounded-3xl border border-[#143527]/10 divide-y divide-[#143527]/10 overflow-hidden"
        >
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-0 px-6 lg:px-8">
              <AccordionTrigger className="font-serif text-lg lg:text-xl text-[#143527] hover:no-underline py-6 text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#143527]/80 leading-relaxed pb-6">
                <p>{f.a}</p>
                {f.list && (
                  <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    {f.list.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
